module.exports = __webpack_public_path__ + "img/active-c.42d1cf3b.png";